<template>
  <div class="admin-user-activation">
    <div class="level">
      <div class="level-left">
        <h2 class="title is-4">{{ $t('pending-registrations') }}</h2>
      </div>
      <div class="level-right">
        <b-button @click="refreshList" :loading="loading">
          {{ $t('button-refresh') }}
        </b-button>
      </div>
    </div>
    
    <b-table :data="pendingUsers" :loading="loading">
      <template slot-scope="props">
        <b-table-column field="username" :label="$t('username')" sortable>
          {{ props.row.username }}
        </b-table-column>
        
        <b-table-column field="name" :label="$t('name')" sortable>
          {{ props.row.firstname }} {{ props.row.lastname }}
        </b-table-column>
        
        <b-table-column field="email" :label="$t('email')" sortable>
          <a :href="`mailto:${props.row.email}`">{{ props.row.email }}</a>
        </b-table-column>
        
        <b-table-column field="created" :label="$t('registration-date')" sortable>
          {{Number(props.row.created) | moment('ll LT')}}
        </b-table-column>
        
        <b-table-column :label="$t('actions')">
          <div class="buttons">
            <b-button size="is-small" type="is-success" @click="activateUser(props.row)">
              {{ $t('activate') }}
            </b-button>
          </div>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Cytomine} from 'cytomine-client';

export default {
  name: 'AdminUserActivation',
  data() {
    return {
      pendingUsers: [],
      loading: false
    };
  },
  async mounted() {
    await this.refreshList();
  },
  methods: {
    async refreshList() {
      this.loading = true;
      try {
        const response = await Cytomine.instance.api.get(`${Cytomine.instance.host}/api/admin/users/pending.json`);
        this.pendingUsers = response.data.collection || response.data.data || [];
      }
      catch (error) {
        this.$notify({type: 'error', text: this.$t('error-loading-pending-users')});
      }
      this.loading = false;
    },
    
    async activateUser(user) {
      try {
        await Cytomine.instance.api.post(`${Cytomine.instance.host}/api/admin/users/${user.id}/activate.json`);
        this.$notify({type: 'success', text: this.$t('user-activated-successfully')});
        await this.refreshList();
      }
      catch (error) {
        this.$notify({type: 'error', text: this.$t('error-activating-user')});
      }
    }
  }
};
</script>

<style scoped>
.admin-user-activation {
  padding: 20px;
}

.level {
  margin-bottom: 20px;
}
</style>
